import { ClientLambdaApi } from '@/api-client.js'
import AgGrid from './models/AgGrid.js'

const getLongGrid = async (longGridPayload) => {
  const longGrid = await ClientLambdaApi.post('/long-grid-data/', longGridPayload)
  return new AgGrid(longGrid.data)
}

const getWideGrid = async (wideGridPayload) => {
  const wideGrid = await ClientLambdaApi.post('/wide-grid-data/', wideGridPayload)
  return new AgGrid(wideGrid.data)
}

const getStoresWithinRadius = async (storeId, radius) => {
  const storesWithinRadius = await ClientLambdaApi.get(`/store/${storeId}/stores-around/${radius}`)
  return storesWithinRadius.data.map(store => store.store_id)
}

export { getLongGrid, getWideGrid, getStoresWithinRadius }



// WEBPACK FOOTER //
// ./src/app/store_growth/Services.js